export default __webpack_public_path__ + "static/media/logo_white.e07a0006.png";